import VueRouter from 'vue-router'
import store from './store'

import Home from './views/Home'
import Shift from './views/Shift'
import Workday from './views/Workday'
import Jobs from './views/Jobs'
import Job from './views/Job'
import JobActions from './views/JobActions'
import JobAction from './views/JobAction'
import Pirates from './views/Pirates'
import Forms from './views/Forms'
import CustomForm from './views/CustomForm'
import AccidentReport from './views/AccidentReport'
import WeeklyReport from './views/WeeklyReport'

const routes = [
  { path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/shift',
    name: 'shift',
    component: Shift,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/workday',
    name: 'workday',
    component: Workday,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: Jobs,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/job/:id',
    name: 'job',
    component: Job,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jobactions',
    name: 'jobactions',
    component: JobActions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/jobaction',
    name: 'jobaction',
    component: JobAction,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/pirates',
    name: 'pirates',
    component: Pirates,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/forms',
    name: 'forms',
    component: Forms,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/customform',
    name: 'customform',
    component: CustomForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/accident',
    name: 'accident',
    component: AccidentReport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/weeklyreport',
    name: 'weeklyreport',
    component: WeeklyReport,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.user.token) {
      next()
      return
    }
    next('/')
  } else {
    next()
  }
})

export default router
